/**
 * @Time    : 2024/01/10 11:41
 * @Author  : tlovet
 * @Software: WebStorm
 */

import { QuestionCircleOutlined, SearchOutlined } from '@ant-design/icons';
import { SelectLang as UmiSelectLang } from '@umijs/max';
import { Input, theme } from 'antd';

export { AvatarDropdown, AvatarName } from './AvatarDropdown';
export { EnvDropdown } from './EnvDropdown';
export { FullScreen } from './FullScreen';
export { ThemeSwitch } from './ThemeSwitch';

export type SiderTheme = 'light' | 'dark';

export const SelectLang = () => {
  return <UmiSelectLang />;
};

export const Question = () => {
  return (
    <div onClick={() => window.open(HELP_DOC_URL)}>
      <QuestionCircleOutlined />
    </div>
  );
};

export const SearchInput = () => {
  const { token } = theme.useToken();
  return (
    <div
      key="SearchOutlined"
      aria-hidden
      style={{
        display: 'flex',
        alignItems: 'center',
        // marginInlineEnd: 24,
      }}
      onMouseDown={(e) => {
        e.stopPropagation();
        e.preventDefault();
      }}
    >
      <Input
        style={{
          borderRadius: 4,
          marginInlineEnd: 12,
          backgroundColor: token.colorBgTextHover,
        }}
        prefix={
          <SearchOutlined
            style={{
              color: token.colorTextLightSolid,
            }}
          />
        }
        placeholder="搜Appkey/主机名/IP"
        variant="borderless"
      />
    </div>
  );
};
